import React from "react";
import {RowContext, TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    visualize,
    submitNotificationSubscribers,
    insertNewRefTableData,
    insertNewNotificationType
} from "../api/api";
import {Button, Space, Modal, notification} from "antd";
import {AppstoreAddOutlined, EyeOutlined} from '@ant-design/icons'
import Checkbox from "antd/es/checkbox/Checkbox";
import TableDataSource from "../utils/TableDataSource";
import {Form} from "@q4us-sw/q4us-ui";


export const AssignSubscribers = ({notification}) => {

    return <div className={`notification_subscription`}>
        <TableV2
            schema = {'notification_subscribers_per_type'}
            fetchConfig={async (schema) => {
                const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                return { data: { statusCode : 200, rows: rows } };
            }}
            fetchData={async () => {
                const error_type = notification.error_type
                const {data: {rows: subscribers}} = await visualize('notification_subscribers') || {}
                const Data = []

                for (let i=0; i<subscribers.length; i++) {
                    Data.push({
                                "user_name": subscribers[i].user_name,
                                "email": subscribers[i].email,
                                "phone_number": subscribers[i].phone_number,
                                "subscribed": subscribers[i][`${error_type}`]
                            })
                }
                Data.sort(function(x, y) {
                    return (x.subscribed === y.subscribed)? 0 : x.subscribed? -1 : 1;
                });
                return {data: {rows: Data, statusCode: 200}}
            }}

            scroll={{y: '100vh', x: 'max-content'}}
            customRenderer={{
                subscribed: (value, row)=>{
                    const onChange = async (e) => {
                        let obj  = {}
                        obj[`${notification.error_type}`] = e.target.checked
                        await submitNotificationSubscribers(obj, row);
                    };
                    return [
                        <Checkbox onChange={onChange} defaultChecked={row.subscribed}/>
                    ]
                },
            }}
        >
        </TableV2>
    </div>
}

const Header = () => {
    const [open, setOpen] = React.useState(false);
    return <React.Fragment>
        <div style={{ textAlign: 'right' , margin: 20}} >
            <Space>
                <Button style={{ width: 160 }} icon={<AppstoreAddOutlined />} onClick={() => setOpen(true)}>Add New Record</Button>
            </Space>
        </div>

        <Modal
            centered
            closable={true}
            onCancel={() => setOpen(false)}
            footer={null}
            title={`Add new Record`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'eas_error_notification_types'} config={async () => {
                const res = await getFeConfig('eas_error_notification_types') || {}
                const { data: { rows = [] } = {} } = res;
                return rows.filter(({ generated }) => !generated).sort(({ sequence_no: a }, { sequence_no: b }) => { return a - b });

            }}

                  submit={async (values) => {
                      const { data } = await insertNewRefTableData(values, 'eas_error_notification_types');
                      const { data : status_code} = await insertNewNotificationType(values.error_type);
                      if (data.statusCode === 200 && status_code === 200) {
                          notification.success({ message: `New record added to Notification Types` })
                      }
                      return true;
                  }} />
        </Modal>

    </React.Fragment>
}

export const NotificationTypes = () => {

    const [setOpen] = React.useState(false)
    const [source] = React.useState(new TableDataSource());

    return <TableV2
        header={Header()}
        fetchConfig={async (schema) => {
            return await getFeConfig(schema)
        }}

        fetchData={async () => {
            return await visualize("eas_error_notification_types");
        }}

        saveData={async (data) => {
            const { data: { statusCode = 400, rows = [] } = {} } = await insertNewRefTableData(data);
            return { data: { statusCode, rows: [data] } };
        }}

        editable={true}
        source={source}
        schema={"eas_error_notification_types"}

        action={{
            name: 'id',
            title: 'Display Subscribers',
            options: TableOperation.Custom
        }}

        getCustomAction={() => {
            return [

                <RowContext.Consumer>
                    {row => <Space>
                        <Button icon={<EyeOutlined/>} onClick={async () =>{
                            Modal.info({
                                title: `Display Subscribers`,
                                content: <React.Fragment>
                                    <AssignSubscribers onCancel={()=>setOpen(false)} onSubmit={()=> {
                                        setOpen(false)
                                        return true;
                                    }} notification={ row.row}
                                    />
                                </React.Fragment>,

                                okType: "ghost",
                                okText: "Close",
                                maskClosable: true,
                                closable: true,
                                keyboard: true,
                                bodyStyle: {overflowX: 'scroll', overflowY: 'scroll', width: 'fit-content', height: '60vh', maxWidth: '75vw'},
                                width: 'fit-content'
                            })
                        }}/>
                    </Space>}

                </RowContext.Consumer>

            ]
        }}

    >

    </TableV2>
}
